"use client"

import { useCallback } from "react"
import type { TFunction } from "i18next"

export const useRelativeTime = (t: TFunction) => {
  const getRelativeTime = useCallback(
    (dateString: string): { label: string; isStale: boolean } => {
      const now = new Date()
      const past = new Date(dateString)
      const diffMs = now.getTime() - past.getTime()
      const diffMin = Math.floor(diffMs / 60000)
      const diffHr = Math.floor(diffMin / 60)

      if (diffHr >= 2) {
        return { label: t("relative_time.over_two_hours"), isStale: true }
      }
      if (diffHr >= 1) {
        return {
          label: t("relative_time.hours_ago", { count: diffHr }),
          isStale: false,
        }
      }
      return {
        label: t("relative_time.minutes_ago", { count: diffMin }),
        isStale: false,
      }
    },
    [t],
  )

  return { getRelativeTime }
}
